import { render, staticRenderFns } from "./KioskMyPlace.vue?vue&type=template&id=be007294&scoped=true&"
import script from "./KioskMyPlace.vue?vue&type=script&lang=js&"
export * from "./KioskMyPlace.vue?vue&type=script&lang=js&"
import style0 from "./KioskMyPlace.vue?vue&type=style&index=0&id=be007294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be007294",
  null
  
)

component.options.__file = "KioskMyPlace.vue"
export default component.exports